"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _excluded = ["id", "icon", "value", "dateFormat", "placeholder", "popperPlacement", "className", "maxDate", "decreaseMonthOnClick", "increaseMonthOnClick", "hasError", "renderCustomHeader", "onClickOutside"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MAX_DATE_PICKER_DATE = new Date('Dec 31 2999');
var HBDatepickerBase = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var id = props.id,
    icon = props.icon,
    value = props.value,
    _props$dateFormat = props.dateFormat,
    dateFormat = _props$dateFormat === void 0 ? 'MM/dd/yyyy' : _props$dateFormat,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'MM/DD/YY' : _props$placeholder,
    _props$popperPlacemen = props.popperPlacement,
    popperPlacement = _props$popperPlacemen === void 0 ? 'bottom-start' : _props$popperPlacemen,
    className = props.className,
    _props$maxDate = props.maxDate,
    maxDate = _props$maxDate === void 0 ? MAX_DATE_PICKER_DATE : _props$maxDate,
    decreaseMonthOnClick = props.decreaseMonthOnClick,
    increaseMonthOnClick = props.increaseMonthOnClick,
    hasError = props.hasError,
    renderCustomHeader = props.renderCustomHeader,
    onClickOutside = props.onClickOutside,
    baseProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], (0, _extends2["default"])({}, baseProps, {
    dateFormat: dateFormat,
    id: id,
    maxDate: maxDate,
    placeholderText: placeholder,
    popperPlacement: popperPlacement,
    ref: ref,
    renderCustomHeader: renderCustomHeader,
    value: value,
    onClickOutside: onClickOutside
  }));
});
var _default = exports["default"] = HBDatepickerBase;
//# sourceMappingURL=HBDatepickerBase.js.map